module.exports = __webpack_public_path__ + "static/media/slide-general-on.ab714141.svg";